import { __read } from 'tslib';
import React__default from 'react';
import { CartContext } from '../context/CartContext.esm.js';
import isEqual from 'lodash/isEqual';
import Markdown from 'markdown-to-jsx';
import { useNvModal, NvModal, NvButton } from '@invitae/ids-react';
import { useMakeActions } from './actions.esm.js';
import { dynamicModalContent } from './content/index.esm.js';
import data from './content/default_validation_error.esm.js';
import { ContentType } from './ModalBuilder.models.esm.js';
import { useMakePostProcessingActions } from './postProcessingActions/index.esm.js';
import modalStyles from './ModalBuilder.module.esm.js';

var ModalBuilder = function (_a) {
    var _b = _a.actionParameters, actionParameters = _b === void 0 ? {} : _b, customPrimaryAction = _a.customPrimaryAction, customSecondaryAction = _a.customSecondaryAction, modalType = _a.modalType, postProcessingParameters = _a.postProcessingParameters;
    var _c = __read(React__default.useState(), 2), data$1 = _c[0], setData = _c[1];
    var actions = useMakeActions(actionParameters);
    var postProcessingActions = useMakePostProcessingActions();
    var clearCartErrors = React__default.useContext(CartContext).clearCartErrors;
    var modalRef = React__default.useRef(null);
    var closeModalDialog = useNvModal(modalRef).closeModalDialog;
    React__default.useEffect(function () {
        var _a, _b;
        if (!modalType) {
            return;
        }
        var currentData = dynamicModalContent(modalType, { errorSubtypes: postProcessingParameters === null || postProcessingParameters === void 0 ? void 0 : postProcessingParameters.errorTypes }) || data;
        setData(currentData);
        (_b = (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.showModal) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [modalType, JSON.stringify(postProcessingParameters === null || postProcessingParameters === void 0 ? void 0 : postProcessingParameters.errorTypes)]);
    var closeModal = React__default.useCallback(function () {
        clearCartErrors();
    }, [clearCartErrors]);
    var clickHandler = React__default.useCallback(function (action) {
        if (action && action in actions) {
            actions[action]();
        }
        closeModal();
        closeModalDialog();
    }, [actions, closeModalDialog, closeModal]);
    var processBodyOrHeaderContent = React__default.useCallback(function (content, postProcessingParameters) {
        var postProcessingAction = content.postProcessingAction, text = content.text;
        if (postProcessingAction && postProcessingAction in postProcessingActions) {
            return postProcessingActions[postProcessingAction](text, postProcessingParameters);
        }
        return text;
    }, [postProcessingActions]);
    var getButtonAction = React__default.useCallback(function (isPrimary, action) {
        if (isPrimary && customPrimaryAction)
            return customPrimaryAction;
        if (!isPrimary && customSecondaryAction)
            return customSecondaryAction;
        return action;
    }, [customPrimaryAction, customSecondaryAction]);
    if (!data$1) {
        return null;
    }
    var _d = data$1 || {}, body = _d.body, _e = _d.buttons, buttons = _e === void 0 ? [] : _e, header = _d.header, _f = _d.type, type = _f === void 0 ? ContentType.error : _f;
    var isDefaultModal = isEqual(data$1, data);
    return (React__default.createElement(NvModal, { classes: {
            modal: modalStyles.modal,
        }, "data-testid": "".concat(isDefaultModal ? 'default' : modalType === null || modalType === void 0 ? void 0 : modalType.toLowerCase(), "-modal"), defaultOpen: true, headerComponent: (header === null || header === void 0 ? void 0 : header.text) && (React__default.createElement(Markdown, { className: modalStyles.header, "data-testid": "modal-header" }, processBodyOrHeaderContent(header, postProcessingParameters))), onDismiss: closeModal, ref: modalRef, showCloseButton: header === null || header === void 0 ? void 0 : header.closeButton, type: type },
        (body === null || body === void 0 ? void 0 : body.text) && (React__default.createElement(Markdown, { className: modalStyles.body }, processBodyOrHeaderContent(body, postProcessingParameters))),
        React__default.createElement("div", { className: modalStyles.buttons }, buttons.map(function (_a) {
            var action = _a.action, isPrimary = _a.isPrimary, text = _a.text;
            return (React__default.createElement(NvButton, { dataTestId: "modal-".concat(isPrimary ? 'primary' : 'secondary', "-button"), key: text, onClick: function () { return clickHandler(getButtonAction(isPrimary, action)); }, variant: isPrimary ? 'primary' : 'secondary' }, text));
        }))));
};

export { ModalBuilder };
//# sourceMappingURL=ModalBuilder.esm.js.map
